import earPNG from '~/assets/images/anatomy/ear.png'
import earWEBP from '~/assets/images/anatomy/ear.webp'
import eyePNG from '~/assets/images/anatomy/eye.png'
import eyeWEBP from '~/assets/images/anatomy/eye.webp'
import nosePNG from '~/assets/images/anatomy/nose.png'
import noseWEBP from '~/assets/images/anatomy/nose.webp'
import pinkyToePNG from '~/assets/images/anatomy/pinky-toe.png'
import pinkyToeWEBP from '~/assets/images/anatomy/pinky-toe.webp'
import GridChoice from '~/pages/anatomy/libs/components/GridChoice'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  {
    key: 'ear',
    i18nKey: 'onboarding.smallestBone.options.ear',
    png: earPNG,
    webp: earWEBP,
  },
  {
    key: 'nose',
    i18nKey: 'onboarding.smallestBone.options.nose',
    png: nosePNG,
    webp: noseWEBP,
  },
  {
    key: 'pinkyToe',
    i18nKey: 'onboarding.smallestBone.options.pinkyToe',
    png: pinkyToePNG,
    webp: pinkyToeWEBP,
  },
  {
    key: 'eye',
    i18nKey: 'onboarding.smallestBone.options.eye',
    png: eyePNG,
    webp: eyeWEBP,
  },
]

const SmallestBone = (props: TPageProps) => (
  <GridChoice
    {...props}
    options={OPTIONS}
    questionKey="onboarding.smallestBone.question"
    question="Where is the smallest bone in the human body located?"
    answersAtBottom
  />
)

export default SmallestBone
